module.exports = __webpack_public_path__ + "static/scale-model-of-bush's-pasture-park-in-salem-oregon-1c3256265b207b0fdb6909d9441f216c.png";